/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { Fragment, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink, generatePath, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useConfig, useDateSelector, useLocationSelector, useUrlParams } from 'app/hooks';

import { MoviesDatesFilter, SessionState, TicketsList, CinemaInfo, NoContent } from 'app/components';
import { EntityContent } from 'app/components/Entity';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useCallback } from 'react';

const getCinemaInfo = (cinemas, id) => {
  const cinema = cinemas.find(el => el.id === id);

  if (cinema) return cinema.hint;

  return null;
};

const propTypes = {
  sessions: PropTypes.arrayOf(
    PropTypes.shape({
      cinemaId: PropTypes.string.isRequired,
      cinemaName: PropTypes.string.isRequired
    })
  ).isRequired,
  sessionss: PropTypes.arrayOf(
    PropTypes.shape({
      cinemaId: PropTypes.string.isRequired,
      cinemaName: PropTypes.string.isRequired
    })
  ).isRequired,

  cinemasLocation: PropTypes.string.isRequired,
  savedLocation: PropTypes.string.isRequired,

  getDateList: PropTypes.func.isRequired,
  onDateSelected: PropTypes.func.isRequired,
  onLocationSelected: PropTypes.func.isRequired,
  savedCinema: PropTypes.string.isRequired,
  movieTitle: PropTypes.string.isRequired,
  movieId: PropTypes.string.isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
    replace: PropTypes.func.isRequired
  }).isRequired,
};

const CommonView = ({
  sessions,
  sessionss,
  cinemasLocation,
  savedLocation,
  onDateSelected,
  onLocationSelected,
  selectCinemaId,
  savedCinema,
  getDateList,
  history,
}) => {
  const cinemas = useSelector(state => state.cinemas.cinemas);
  const dates = useSelector(state => state.movies.datesDetails);
  const locations = useSelector(state => state.layout.locations);
  const [sessionCheckLength, setSessionCheckLength] = useState(false);
  const [formatedSessions, setFormatedSessions] = useState(sessions);

  const { routes } = useConfig();
  const [t] = useTranslation();
  const ref = useRef(null);
  const { location, date } = useUrlParams('location', 'date');
  const { redLabelLocation, onSelectLocation } = useLocationSelector(
    location,
    savedLocation,
    onLocationSelected
  );
  const { redLabelDate, onSelectDate } = useDateSelector(date, onDateSelected);
  const locationCinema = useLocation();
  const [redLabelCinema, setRedLabelCinema] = useState(false);
  const [searchCinemaIdvalue, setSearchCinemaIdvalue] = useState('');
  const urlSearchParams = new URLSearchParams(history.location.search);
  let searchMovieId = localStorage.getItem("searchMovieId");
  const cinemaPage = locationCinema.search.split('&')[1].split("=")[0] !== "location"
  useEffect(() => {
    if (selectCinemaId) {
      setSessionCheckLength(sessions.every(element => selectCinemaId !== element?.cinemaId))
    }
  }, [selectCinemaId, sessions])
  useEffect(() => {
    if (searchMovieId || searchCinemaIdvalue) {
      // ! 2
      if (searchCinemaIdvalue !== 'all') {
        getDateList({ movieId: searchMovieId, cinemaId: selectCinemaId ? selectCinemaId : searchCinemaIdvalue });
      }
      else {
        getDateList({ movieId: searchMovieId, cinemaId: selectCinemaId ? selectCinemaId : '' });
      }
    }

  }, [searchMovieId, searchCinemaIdvalue]);
  const id = sessionStorage.getItem('cinemaId')

  const [windowSize, setWindowSize] = useState();

  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, [window])
  const onSelectCinema = useCallback(
    valueFromSelect => {
      if (!valueFromSelect || !valueFromSelect.length) return;
      const { value } = valueFromSelect[0];
      setRedLabelCinema(value !== 'all');
      if (value === urlSearchParams.get('cinemaId')
        &&
        value === searchCinemaIdvalue
        && value === savedCinema
      ) {
        return;
      }

      setSearchCinemaIdvalue('');
      if (value !== 'all') {
        setSearchCinemaIdvalue(value);
      }
      else {
        setSearchCinemaIdvalue(value);
        setRedLabelCinema(value === "all");
      }
      // urlSearchParams.set('cinemaId', value);
      // history.replace({ search: `?${urlSearchParams.toString()}` });
    },
    [urlSearchParams]
  );
  window.addEventListener('resize', function () {
    setWindowSize(window.innerWidth);
  }, true);

  const handleClick = (cinemaName) => {
    const selectedCinemaInfo = {
      cinemaName,
      refId: `data-${cinemaName}`,
    };
    localStorage.setItem('selectedCinema', JSON.stringify(selectedCinemaInfo));
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("selectedCinema"));
    if (data) {
      setTimeout(() => {
        scrollTo(data.refId);
      }, 100);
    }
  }, [sessions]);

  const scrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    const isDesktop = window.innerWidth >= 992;
    if (element && isDesktop) {
      const yOffsetDesktop = -100;
      requestAnimationFrame(() => {
        const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffsetDesktop;
        window.scrollTo({ top: yPosition, behavior: 'smooth' });
      });
      localStorage.removeItem("selectedCinema");
    }
  }

  useEffect(() => {
    const prioritizedCinema = "Cineplexx Ljubljana Rudnik";

    const sortedSessions = sessions.sort((a, b) => {
      if (a.cinemaName === prioritizedCinema) return -1;
      if (b.cinemaName === prioritizedCinema) return 1;

    return 0;
    });

    if(process.env.REACT_APP_COUNTRY === 'svn'){
      setFormatedSessions(sortedSessions);
    }

  }, [sessions])

  return (
    <Fragment>
      {windowSize <= 992 ? null : (
        id === null ?
          (cinemaPage ?
            <MoviesDatesFilter
              cinemas={cinemas}
              selectedCinema={searchCinemaIdvalue || savedCinema}
              onSelectCinema={onSelectCinema}
              redLabelCinema={redLabelCinema}
              dates={dates.length ? dates : [date]}
              selectedDate={date}
              onSelectDate={onSelectDate}
              redLabelDate={redLabelDate}
              sessions={sessionss}
            />
            :
            <MoviesDatesFilter
              locations={locations}
              selectedLocation={cinemasLocation || savedLocation}
              onSelectLocation={onSelectLocation}
              redLabelLocation={redLabelLocation}
              dates={dates.length ? dates : [date]}
              selectedDate={date}
              onSelectDate={onSelectDate}
              redLabelDate={redLabelDate}
            />

          )
          :
          <MoviesDatesFilter
            // locations={[]}
            // selectedLocation={cinemasLocation || savedLocation}
            onSelectLocation={() => { }}
            // redLabelLocation={redLabelLocation}
            dates={dates.length ? dates : [date]}
            selectedDate={date}
            onSelectDate={onSelectDate}
            redLabelDate={redLabelDate}
          />)}
      {sessions ? (
        <Fragment>
          <SessionState />
          {cinemas.length > 0 && formatedSessions.map(session => {
            const { cinemaName, cinemaId, tickets } = session;
            let cinemaNameUrl = cinemas.find(c => c?.id === session?.cinemaId);
            if (selectCinemaId || searchCinemaIdvalue) {
              if (selectCinemaId === cinemaId || searchCinemaIdvalue === cinemaId || searchCinemaIdvalue === 'all') {
                return (
                  <Fragment key={cinemaName}>
                    <EntityContent>
                      <div
                        id={`data-${cinemaName}`}
                        ref={ref}
                        onClick={() => handleClick(cinemaName)} >
                        <NavLink
                          to={{
                            pathname: generatePath(routes.cinemaDetails.pattern, {
                              // id: cinemaName.split(" ").join("-")
                              id: cinemaNameUrl?.cinemaUrlName.split(" ").join("-")
                            }),
                            search: `?date=${date}`
                          }}
                          className="b-entity-content__title b-entity-content__link"
                        >
                          {cinemaName}
                        </NavLink>
                        <TicketsList tickets={tickets} />
                      </div>
                    </EntityContent>
                    {/* <CinemaInfo message={getCinemaInfo(cinemas, cinemaId)} /> */}
                  </Fragment>
                );
              }

            } else {
              return (
                <Fragment key={cinemaName} >
                  <EntityContent>
                    <div
                      id={`data-${cinemaName}`}
                      ref={ref}
                      onClick={() => handleClick(cinemaName)} >
                      <NavLink
                        to={{
                          pathname: generatePath(routes.cinemaDetails.pattern, {
                            // id: cinemaName.split(" ").join("-")
                            id: cinemaNameUrl?.cinemaUrlName.split(" ").join("-")
                          }),
                          search: `?date=${date}`
                        }}
                        className="b-entity-content__title b-entity-content__link"
                      >
                        {cinemaName}
                      </NavLink>
                      <TicketsList tickets={tickets} />
                    </div>
                  </EntityContent>
                  {/* <CinemaInfo message={getCinemaInfo(cinemas, cinemaId)} /> */}
                </Fragment>
              );
            }
          })}
          {
            ((sessionCheckLength) ?
              <NoContent svgId="no-tickets" text={t("movies.no_sessions")} />
              : null)
          }
        </Fragment>
      ) : null}
    </Fragment>
  );
};

CommonView.propTypes = propTypes;
export default CommonView;
